import moment from "moment";
import { getRealStartEndDate } from "utilities/showDateUtils";
import { type ShowDates } from "./models";

export const isBeforeMinYear = (startDate: moment.Moment) => startDate.year() < serverReference.constants.appointment.minYear;
export const isAfterMaxYear = (endDate: moment.Moment) => endDate.year() > serverReference.constants.appointment.maxYear;
export const isStartAfterEnd = (isAllDay: boolean, start: moment.Moment, end: moment.Moment) => {
  if (isAllDay) {
    return start.isSameOrAfter(end);
  }

  return start.isAfter(end);
};

export const areDatesTooFarApart = (startDate: moment.Moment, endDate: moment.Moment) => {
  return Math.abs(endDate.diff(startDate, "days")) >= serverReference.constants.appointment.maxDurationDays;
};

export const areShowDatesValid = (showDates: ShowDates) => {
  const { startRealDate, endRealDate } = getRealStartEndDate(showDates);

  const endDateBeforeStartDate = isStartAfterEnd(showDates.mode === "allDay", startRealDate, endRealDate);
  const tooBigDateDifference = areDatesTooFarApart(startRealDate, endRealDate);
  const beforeMinyear = isBeforeMinYear(startRealDate);
  const afterMaxYear = isAfterMaxYear(endRealDate);

  return !endDateBeforeStartDate && !tooBigDateDifference && !beforeMinyear && !afterMaxYear;
};
